import { Box, CircularProgress, Stack, Typography, useMediaQuery } from "@mui/material";
import { getBudgetYears } from "components/Budget/helpers";

import DropdownSelector from "../DropdownSelector";
import WorkspaceViewSelector from "./WorkspaceModeSelector";

export default function WorkspacePageHeader({
  title,
  currentYear,
  onYearChange,
  viewMode,
  onViewModeChange,
  cardGridKey,
  isLoading = false,
  additionalControls = null,
  className = "headerWithMenuButton",
  alignTitle = "start",
}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"), { noSsr: true });

  const isYearSelectorVisible = currentYear !== undefined && onYearChange !== undefined;
  const isViewSelectorVisible = viewMode !== undefined && onViewModeChange !== undefined;

  return (
    <>
      {isMobile ? (
        (title || isYearSelectorVisible || isViewSelectorVisible || additionalControls || isLoading) && (
          <Stack
            direction="column"
            marginBottom={3}
            sx={{
              gap: "1rem",
            }}
          >
            {(() => {
              const elementsCount = [
                isYearSelectorVisible && getBudgetYears().length > 0,
                isViewSelectorVisible,
              ].filter(Boolean).length;

              const shouldSplit = title && elementsCount > 1;

              if (shouldSplit) {
                return (
                  <>
                    <Stack direction="row" alignItems="center" sx={{ gap: "1rem" }}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "1.5rem",
                          fontWeight: 600,
                          lineHeight: 1,
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        {title}
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: "40px",
                          minHeight: "40px",
                        }}
                      >
                        {isLoading && <CircularProgress />}
                      </Box>
                    </Stack>

                    <Stack
                      direction="row"
                      alignItems="center"
                      sx={{
                        gap: "1rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {isYearSelectorVisible && getBudgetYears().length > 0 && (
                        <DropdownSelector value={currentYear} onChange={onYearChange} options={getBudgetYears()} />
                      )}
                      {additionalControls}
                      {isViewSelectorVisible && (
                        <WorkspaceViewSelector
                          workspaceMode={viewMode}
                          setWorkspaceMode={onViewModeChange}
                          cardGridKey={cardGridKey}
                        />
                      )}
                    </Stack>
                  </>
                );
              } else {
                return (
                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={{
                      gap: "1rem",
                      flexWrap: "wrap",
                    }}
                  >
                    {title && (
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "1.5rem",
                          fontWeight: 600,
                          lineHeight: 1,
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        {title}
                      </Typography>
                    )}

                    {isYearSelectorVisible && getBudgetYears().length > 0 && (
                      <DropdownSelector value={currentYear} onChange={onYearChange} options={getBudgetYears()} />
                    )}
                    {additionalControls}
                    {isViewSelectorVisible && (
                      <WorkspaceViewSelector
                        workspaceMode={viewMode}
                        setWorkspaceMode={onViewModeChange}
                        cardGridKey={cardGridKey}
                      />
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "40px",
                        minHeight: "40px",
                      }}
                    >
                      {isLoading && <CircularProgress />}
                    </Box>
                  </Stack>
                );
              }
            })()}
          </Stack>
        )
      ) : (
        <Stack direction="row" spacing={3} className={className} sx={{ alignItems: alignTitle }}>
          {title && <Typography variant="h1">{title}</Typography>}

          <Stack
            alignItems="center"
            sx={{
              gap: "1.5rem",
              flexDirection: "row",
            }}
          >
            {isYearSelectorVisible && getBudgetYears().length > 0 && (
              <DropdownSelector value={currentYear} onChange={onYearChange} options={getBudgetYears()} />
            )}
            {additionalControls}
            {isViewSelectorVisible && (
              <WorkspaceViewSelector
                workspaceMode={viewMode}
                setWorkspaceMode={onViewModeChange}
                cardGridKey={cardGridKey}
              />
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "40px",
                minHeight: "40px",
              }}
            >
              {isLoading && <CircularProgress />}
            </Box>
          </Stack>
        </Stack>
      )}
    </>
  );
}
